function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Dankort = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgDankort = function SvgDankort(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0)"
    }, /*#__PURE__*/React.createElement("rect", {
      width: 60,
      height: 40,
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.3633 3.22612C51.8319 3.46721 54.6802 2.74393 56.674 4.04584C58.7154 5.2031 60.092 7.37295 59.9971 9.88033L45.4706 9.92855C45.2332 10.025 45.0908 10.4107 44.806 10.6036C42.7647 13.111 40.7708 15.7148 38.6821 18.1258C38.9194 15.4255 39.0618 12.6288 39.3941 9.92855H27.3837C27.2887 12.3877 27.1463 14.7504 27.0039 17.0649C26.4817 14.4129 24.3454 11.5198 21.6395 10.7483C20.3578 10.3625 19.171 10.0732 17.8417 9.97677L-2.90363 10.0732C-2.90363 10.1214 -2.99857 10.1214 -2.99857 10.0732C-3.04605 7.71048 -1.90671 5.58885 0.0871231 4.33516C0.941624 3.80475 1.89107 3.37078 2.93546 3.27434L49.3633 3.22612Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M59.9978 28.6375C59.9978 28.6857 59.9503 28.6857 59.9978 28.7339C57.0545 25.5033 54.4435 21.9351 51.88 18.4633L51.9275 18.3186C54.5385 15.5219 57.007 12.6288 59.9503 10.1696L60.0452 10.2179V28.6375H59.9978Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.9436 18.849C15.9911 19.717 15.4214 20.4403 14.7568 20.9707C13.0953 22.2726 10.6742 21.6457 8.53796 21.7422L8.91774 16.7756C11.054 16.9203 15.1841 16.0041 15.9436 18.849Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M44.8541 28.3C45.0915 29.1197 45.7561 28.9268 46.4207 28.9268H59.9978C60.0927 31.4824 58.5736 34.038 56.1525 35.0988C55.2505 35.4846 54.2536 35.6775 53.2092 35.6775H30.4225L2.88863 35.7739C0.609966 35.581 -1.6687 33.8451 -2.5232 31.6271C-2.80804 30.8556 -2.99792 29.9394 -2.99792 29.0715L17.3202 28.975C20.4059 28.5893 23.3492 27.2391 25.1531 24.346C25.8177 23.2852 26.2925 22.1762 26.7197 21.0671C26.5298 23.6709 26.4349 26.3712 26.15 29.0715C29.9953 29.0232 38.0656 29.0715 38.0656 29.0715C38.1605 25.7926 38.3029 22.3208 38.5403 19.0901L44.8541 28.3Z",
      fill: "#ED1C24"
    }), /*#__PURE__*/React.createElement("rect", {
      width: 60,
      height: 10,
      fill: "#ED1C24"
    }), /*#__PURE__*/React.createElement("rect", {
      y: 29,
      width: 60,
      height: 11,
      fill: "#ED1C24"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0"
    }, /*#__PURE__*/React.createElement("rect", {
      width: 60,
      height: 40,
      fill: "white"
    })))));
  };

  var _default = SvgDankort;
  _exports["default"] = _default;
});